import styled from 'styled-components';
import {
  EXPANDER_BUTTON_SIZE,
  TIMELINES_ITEM_ROW_HEIGHT,
  EXPANDER_BUTTON_RIGHT_MARGIN,
} from '../consts';
import { colors } from '@ardoq/design-tokens';
import { Icon, IconName } from '@ardoq/icons';

const GroupExpanderContainer = styled.div`
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 ${EXPANDER_BUTTON_SIZE}px;
  align-self: flex-start;
  margin-top: ${TIMELINES_ITEM_ROW_HEIGHT / 2 - EXPANDER_BUTTON_SIZE / 2}px;
  margin-right: ${EXPANDER_BUTTON_RIGHT_MARGIN}px;
  background-color: ${colors.grey300};
  width: ${EXPANDER_BUTTON_SIZE}px;
  height: ${EXPANDER_BUTTON_SIZE}px;
  border-radius: 2px;
`;
type GroupExpanderProps = {
  onClick: (e: React.MouseEvent<HTMLDivElement>) => void;
  isCollapsed: boolean;
};
export const GroupExpanderModernized = ({
  onClick,
  isCollapsed,
}: GroupExpanderProps) => (
  <GroupExpanderContainer onClick={onClick} className="expander">
    <Icon
      iconName={isCollapsed ? IconName.ADD : IconName.REMOVE}
      color={colors.grey500}
      style={{ fontSize: '12px' }}
    />
  </GroupExpanderContainer>
);
